import React from "react";

const ChildCarer = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-ChildCarer"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-ChildCarer"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M24,11.5a3.5,3.5,0,0,0-2.149-3.226,10,10,0,0,0-19.7,0,3.5,3.5,0,0,0,1.119,6.718,10.607,10.607,0,0,0,2.071,2.955,8.908,8.908,0,0,0-2.272,4.928A1,1,0,0,0,4.06,24H19.919a1,1,0,0,0,.992-1.124,8.9,8.9,0,0,0-2.261-4.918,10.622,10.622,0,0,0,2.082-2.966A3.5,3.5,0,0,0,24,11.5Zm-3.752,1.473a.993.993,0,0,0-1.117.651C18.215,16.222,15.13,19,12,19s-6.215-2.78-7.131-5.378a.994.994,0,0,0-1.117-.651A1.606,1.606,0,0,1,3.5,13a1.5,1.5,0,0,1-.27-2.972,1,1,0,0,0,.816-.878A7.966,7.966,0,0,1,8.711,2.71a3.534,3.534,0,1,0,6.578,0,7.966,7.966,0,0,1,4.665,6.44,1,1,0,0,0,.816.878A1.5,1.5,0,0,1,20.5,13,1.606,1.606,0,0,1,20.248,12.973Z" />
      <circle cx="9.5" cy="11.5" r="1.5" />
      <circle cx="14.5" cy="11.5" r="1.5" />
    </svg>
  );
};

export default ChildCarer;
